module.exports = __webpack_public_path__ + "c167f959a5e4cee9b1aec6482cb5d914.png";


//////////////////
// WEBPACK FOOTER
// ./assets/image/newport-world-resorts.png
// module id = 1160
// module chunks = 0